import './ReviewsTab.scss';

import React, {
  memo,
  useState,
} from 'react';

import {
  Col,
  Row,
} from 'antd';

import {
  IUserReviewsFilters,
  UserProfileTabItemType,
} from '../../../../types/tqConnectTypes/user';
import { UserAccountType } from '../../../../types/userTypes';
import { IUserProfileDetails } from '../../types';
import UserReviews from './UserReviews';

const initialFilters: IUserReviewsFilters = {
  type: UserProfileTabItemType.RECEIVED,
  rating: null,
};

interface Props {
  userProfileId: string;
  userProfileDetails: IUserProfileDetails;
  accountType: UserAccountType;
  viewerType: UserAccountType;
  isViewerSelf?: boolean;
  reviewReceived: number;
  reviewGiven: number;
}

const ReviewsTab: React.FC<Props> = ({
  userProfileId,
  userProfileDetails,
  accountType,
  viewerType,
  isViewerSelf,
  reviewReceived,
  reviewGiven,
}) => {
  const [filters, setFilters] = useState<IUserReviewsFilters>(initialFilters);

  const onChangeFilters = <Key extends keyof IUserReviewsFilters>(
    key: Key,
    value: IUserReviewsFilters[Key],
  ) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  console.log(viewerType);

  return (
    <div className="container user-profile__tab user-profile__tab--reviews">
      <Row gutter={16}>
        <Col
          xs={24}
          sm={24}
          md={accountType === 'creator' ? 24 : 14}
          lg={accountType === 'creator' ? 24 : 14}>
          <UserReviews
            userName={userProfileDetails.userProfile.name}
            viewerType={viewerType}
            isViewerSelf={isViewerSelf}
            filters={filters}
            onChangeFilters={onChangeFilters}
            reviewReceived={reviewReceived}
            reviewGiven={reviewGiven}
            userProfileId={userProfileId}
          />
        </Col>
      </Row>
    </div>
  );
};

export default memo(ReviewsTab);
